const state = {
  permission: []
}

const mutations = {
  SET_PERMISSION(state, permission) {
    state.permission = permission
  }
}

const actions = {
  setPermission({ commit }, permission) {
    commit('SET_PERMISSION', permission)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}